export default "__VITE_ASSET__BUL52QfU__"